import CartTable from '../components/cart-table';

document.addEventListener('DOMContentLoaded', () => {
  if (document.body.classList.contains('template-cart')) {
    CartTable().init();
  }
});
